$(document).ready(function () {
    $("a:not([href])").css("cursor", "text");
    $("a:not([href]) img").css("cursor", "text");
});



$(document).ready(function () {
    var emailInput = $(".contact-email");
    var emailError = $(".email-error");
    var submitBtn = $(".submit-btn");

    function validateEmail() {
        var email = emailInput.val().trim();
        var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (emailPattern.test(email)) {
            emailError.hide();
            submitBtn.prop("disabled", false); // Enable button
        } else {
            emailError.show();
            submitBtn.prop("disabled", true); // Disable button
        }
    }

    // Validate while typing
    emailInput.on("input", validateEmail);

    // Prevent form submission if invalid
    $(".contact-form").on("submit", function (event) {
        if (submitBtn.prop("disabled")) {
            event.preventDefault();
        }
    });
});